export function quantityFormate (quantity) {
    return Number(quantity).toLocaleString() + ' шт.'
}